@if (invalidContext) {
  <div>
    <h3 class="panel-title">Hmm...</h3>
    Somehow you've arrived here without the required URL parameters to perform a password reset. Do you mind checking
    the link in your email and trying again?
  </div>
} @else {
  @if (!!userEmail) {
    <h3 class="panel-title">Reset password for {{ userEmail }}</h3>
    @if (!resetSuccessful) {
      <form [formGroup]="resetPasswordFormModel" (ngSubmit)="resetPassword()">
        <div class="flex-center-column light-control-host">
          <div class="full-width margin-top">Give us a new password and we'll get you fixed up.</div>
          <div class="flex-center-row full-width margin-top field-issue-container">
            <input
              id="reset-pword"
              class="arpio-input"
              type="password"
              placeholder="Password"
              formControlName="password"
              autocomplete="new-password"
            />
            @if (!!passwordError) {
              <div class="field-issue">
                <i class="fa-utility fa-semibold fa-circle-exclamation"></i> {{ passwordError }}
              </div>
            }
          </div>
          <div class="flex-center-row full-width field-issue-container">
            <input
              id="confirm-pword"
              class="arpio-input"
              type="password"
              placeholder="Confirm password"
              formControlName="confirmPassword"
              autocomplete="new-password"
            />
            @if (!!confirmPasswordError) {
              <div class="field-issue">
                <i class="fa-utility fa-semibold fa-circle-exclamation"></i> {{ confirmPasswordError }}
              </div>
            }
          </div>
          <button
            busy-button
            [busy]="resetInProgress"
            class="arpio-button"
            type="submit"
            [disabled]="!resetButtonEnabled"
          >
            RESET PASSWORD
          </button>
        </div>
      </form>
    } @else {
      Your password has been updated! <a routerLink="{{ uiService.buildLoginUrl() }}">Click here</a> to login.
    }
  }
}
